import { gql } from "@apollo/client";

export default gql`
  mutation createGeneralDoc(
    $time: Date
    $branch: String
    $opType: Int
    $docNo: String
    $prefix: String
    $title: String
    $desc: String
    $amount: Float
    $items: String
    $invoiceitems: String
    $customer: CustomerInput
    $supplier: SupplierInput
    $employee: EmployeeInput
    $department: DepartmentInput
    $project: ProjectInput
    $resourse: ResourseInput
    $contract: ContractInput
    $stockId: String
    $stockName: String
    $stockNameAr: String
    $debitAcc: Int
    $creditAcc: Int
    $uploadId: String
    $attachments: String
    $userId: String
  ) {
    createGeneralDoc(
      time: $time
      branch: $branch
      opType: $opType
      docNo: $docNo
      prefix: $prefix
      title: $title
      desc: $desc
      amount: $amount
      items: $items
      invoiceitems: $invoiceitems
      customer: $customer
      supplier: $supplier
      employee: $employee
      department: $department
      project: $project
      resourse: $resourse
      contract: $contract
      stockId: $stockId
      stockName: $stockName
      stockNameAr: $stockNameAr
      debitAcc: $debitAcc
      creditAcc: $creditAcc
      attachments: $attachments
      uploadId: $uploadId
      userId: $userId
    ) {
      ok
      message
      data
      error
    }
  }
`;
